export const environment = {
  production: true,
  config: 'env.config.json',
};
